import { Sun, Leaf, Sparkles, Clock, ShieldCheck, Heart } from "lucide-react";
import { IMAGES } from "@/lib/brand";
import { useReveal } from "@/lib/useReveal";

const ITEMS = [
  {
    icon: Sun,
    title: "Fără UV",
    text: "Obții un bronz superb fără expunerea la razele UV.",
  },
  {
    icon: Leaf,
    title: "Aspect Natural",
    text: "Nuanță uniformă și elegantă, fără efect portocaliu.",
  },
  {
    icon: Sparkles,
    title: "Produse Premium",
    text: "Folosim exclusiv Norvell și Sjolie.",
  },
  {
    icon: Clock,
    title: "Rezultate Rapide",
    text: "Aplicare profesională în aproximativ 20 de minute.",
  },
  {
    icon: ShieldCheck,
    title: "Sigur pentru piele",
    text: "Formule profesionale atent selecționate.",
  },
  {
    icon: Heart,
    title: "Încredere și Strălucire",
    text: "Un look radiant pentru orice ocazie.",
  },
];

export default function Benefits() {
  const r = useReveal();
  const rImage = useReveal();
  return (
    <section
      id="beneficii"
      data-testid="benefits-section"
      className="py-24 sm:py-32 bg-[#F5E6D3]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div ref={r.ref} className={`max-w-2xl mb-16 ${r.className}`}>
          <div className="section-label mb-4">De ce noi</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]">
            De ce să alegi <em className="italic text-[#B88746]">The Best Bronze</em>
          </h2>
          <p className="mt-5 text-[#3B2A22]/70 max-w-xl">
            Fiecare detaliu — de la formulele profesionale până la atmosfera din studio —
            este gândit pentru o experiență premium și un rezultat impecabil.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {ITEMS.map((item, i) => (
            <BenefitCard key={item.title} item={item} index={i} />
          ))}
        </div>

        {/* Bronz creat pentru tine — Before & After */}
        <div
          ref={rImage.ref}
          className={`mt-24 sm:mt-32 grid lg:grid-cols-12 gap-12 items-center ${rImage.className}`}
          data-testid="before-after-block"
        >
          <div className="lg:col-span-5 space-y-6">
            <div className="section-label">Rezultate reale</div>
            <h3 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#3B2A22] leading-[1.05]">
              Bronz creat <em className="italic text-[#B88746]">pentru tine</em>
            </h3>
            <p className="text-[#3B2A22]/75 leading-relaxed">
              Fiecare ședință este adaptată tipului tău de piele și nuanței dorite.
              Rezultatul: un bronz uniform, natural, cu o tranziție impecabilă — exact
              așa cum se vede în imaginea alăturată.
            </p>
            <p
              className="text-sm leading-relaxed text-[#8A6E59] italic border-l-2 border-[#B88746]/50 pl-4"
              data-testid="benefits-trust-note"
            >
              Rezultatul final se observă după dezvoltarea completă a bronzului și
              clătirea ghidului de culoare, lăsând pielea cu un aspect natural,
              uniform și luminos.
            </p>
          </div>
          <div className="lg:col-span-7">
            <div className="relative img-zoom rounded-[2rem] overflow-hidden border border-[#D7B899]/40 bg-[#FFFDF9]">
              <img
                src={IMAGES.beforeAfter}
                alt="Comparativ înainte și după spray tan organic"
                className="w-full h-auto object-contain"
                data-testid="before-after-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function BenefitCard({ item, index }) {
  const r = useReveal();
  const Icon = item.icon;
  return (
    <div
      ref={r.ref}
      className={r.className}
      style={{ transitionDelay: `${index * 60}ms` }}
      data-testid={`benefit-card-${index}`}
    >
      <div className="tbb-card h-full flex flex-col gap-4">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center"
          style={{ background: "rgba(184,135,70,0.12)", color: "#B88746" }}
        >
          <Icon size={20} strokeWidth={1.6} />
        </div>
        <h3 className="font-serif text-2xl text-[#3B2A22]">{item.title}</h3>
        <p className="text-[#3B2A22]/70 text-sm leading-relaxed">{item.text}</p>
      </div>
    </div>
  );
}
